import type { FC } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { Box, Button, CircularProgress, Typography } from '@mui/material'

interface BulkActionBarProps {
  readonly selectedCount: number
  readonly actionLabel: string
  readonly onAction: () => void
  readonly isActioning: boolean
}

export const BulkActionBar: FC<BulkActionBarProps> = ({
  selectedCount,
  actionLabel,
  onAction,
  isActioning,
}) => {
  if (selectedCount === 0) return null

  return (
    <Box role="toolbar" aria-label="Bulk actions" sx={toolbarSx}>
      <Typography variant="body2" aria-live="polite" aria-atomic="true" sx={countSx}>
        {selectedCount} selected
      </Typography>
      <Button
        variant="contained"
        color="error"
        size="small"
        onClick={onAction}
        disabled={isActioning}
        aria-label={`${actionLabel} ${selectedCount} selected items`}
        startIcon={isActioning ? <CircularProgress size={16} color="inherit" /> : undefined}
      >
        {actionLabel} {selectedCount}
      </Button>
    </Box>
  )
}

// ---------------------------------------------------------------------------
// Styles
// ---------------------------------------------------------------------------

const toolbarSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  px: 2,
  py: 1,
  backgroundColor: 'action.selected',
  borderBottom: 1,
  borderColor: 'divider',
}

const countSx: SxProps<Theme> = {
  color: 'text.secondary',
  fontWeight: 500,
}
